import { motion, useReducedMotion } from 'framer-motion'

// --- Constants matching design-preview-v2.html calendar ---
const HOUR_HEIGHT = 60 // px per hour (identical to design-preview-v2.html)
const HOURS = ['07:00','08:00','09:00','10:00','11:00','12:00','13:00','14:00','15:00','16:00','17:00','18:00','19:00','20:00','21:00']
const DAYS = ['Mo','Di','Mi','Do','Fr','Sa','So']
const GRID_HEIGHT = (HOURS.length - 1) * HOUR_HEIGHT // 840px — covers all viewports

// Booking pool — realistic, branchenspezifisch, deterministisch (kein Math.random)
interface Booking {
  id: number
  label: string
  time: string
  duration: number // in hours
  col: number // 1–7
  color: string
}

const BOOKINGS: Booking[] = [
  { id:  0, label: 'Personal Training',   time: '07:30', duration: 1,   col: 1, color: '#C2185B' },
  { id:  1, label: 'Pilates',             time: '07:00', duration: 1,   col: 2, color: '#AD1457' },
  { id:  2, label: 'Spinning',            time: '07:00', duration: 1,   col: 3, color: '#4A148C' },
  { id:  3, label: 'Zahnreinigung',       time: '08:00', duration: 1,   col: 4, color: '#0288D1' },
  { id:  4, label: 'Bootcamp',            time: '07:00', duration: 1,   col: 5, color: '#2E7D32' },
  { id:  5, label: 'Brautstyling',        time: '09:30', duration: 2,   col: 6, color: '#880E4F' },
  { id:  6, label: 'Personal Training',   time: '07:00', duration: 1,   col: 7, color: '#388E3C' },
  { id:  7, label: 'Haarschnitt',         time: '09:00', duration: 1,   col: 1, color: '#006064' },
  { id:  8, label: 'Ernährungsberatung',  time: '08:30', duration: 1.5, col: 2, color: '#33691E' },
  { id:  9, label: 'Nagelstudio',         time: '08:30', duration: 1,   col: 3, color: '#7B1FA2' },
  { id: 10, label: 'Physiotherapie',      time: '09:30', duration: 1.5, col: 4, color: '#BF360C' },
  { id: 11, label: 'Yoga Kurs',           time: '08:00', duration: 1.5, col: 5, color: '#0277BD' },
  { id: 12, label: 'Jonas K.',            time: '12:00', duration: 1,   col: 6, color: '#E65100' },
  { id: 13, label: 'Anna K.',             time: '10:00', duration: 1,   col: 7, color: '#6A1B9A' },
  { id: 14, label: 'Färben',              time: '10:30', duration: 2,   col: 1, color: '#6D4C41' },
  { id: 15, label: 'Massage',             time: '11:00', duration: 2,   col: 2, color: '#00838F' },
  { id: 16, label: 'Max Müller',          time: '10:30', duration: 2,   col: 3, color: '#1B5E20' },
  { id: 17, label: 'Sarah L.',            time: '11:30', duration: 1,   col: 4, color: '#37474F' },
  { id: 18, label: 'Haarschnitt',         time: '10:00', duration: 1,   col: 5, color: '#F57C00' },
  { id: 19, label: 'Fotoshooting',        time: '13:30', duration: 1.5, col: 6, color: '#01579B' },
  { id: 20, label: 'Hot Stone',           time: '11:30', duration: 1.5, col: 7, color: '#C2185B' },
  { id: 21, label: 'Beratung',            time: '13:00', duration: 1.5, col: 1, color: '#AD1457' },
  { id: 22, label: 'Dr. Schmidt',         time: '13:30', duration: 1,   col: 2, color: '#4A148C' },
  { id: 23, label: 'Kosmetik',            time: '13:00', duration: 1,   col: 3, color: '#0288D1' },
  { id: 24, label: 'Team-Meeting',        time: '14:00', duration: 1.5, col: 4, color: '#2E7D32' },
  { id: 25, label: 'Barber',              time: '11:30', duration: 1,   col: 5, color: '#880E4F' },
  { id: 26, label: 'Business Call',       time: '16:00', duration: 1,   col: 6, color: '#388E3C' },
  { id: 27, label: 'Yin Yoga',            time: '14:00', duration: 1,   col: 7, color: '#006064' },
  { id: 28, label: 'Coaching',            time: '15:00', duration: 1,   col: 1, color: '#33691E' },
  { id: 29, label: 'Maniküre',            time: '15:00', duration: 1,   col: 2, color: '#7B1FA2' },
  { id: 30, label: 'Wellness',            time: '14:30', duration: 2,   col: 3, color: '#BF360C' },
  { id: 31, label: 'Bartpflege',          time: '16:00', duration: 1,   col: 4, color: '#0277BD' },
  { id: 32, label: 'Lash Lifting',        time: '13:30', duration: 1,   col: 5, color: '#E65100' },
  { id: 33, label: 'Kinderhaarschnitt',   time: '17:30', duration: 1,   col: 6, color: '#6A1B9A' },
  { id: 34, label: 'Yoga',                time: '16:30', duration: 1,   col: 7, color: '#6D4C41' },
  { id: 35, label: 'Barber',              time: '17:30', duration: 1,   col: 1, color: '#00838F' },
  { id: 36, label: 'Steuerberatung',      time: '16:30', duration: 1,   col: 2, color: '#1B5E20' },
  { id: 37, label: 'Tom B.',              time: '17:00', duration: 1,   col: 3, color: '#37474F' },
  { id: 38, label: 'Termin',              time: '18:00', duration: 1,   col: 4, color: '#F57C00' },
  { id: 39, label: 'Probetraining',       time: '15:00', duration: 1,   col: 5, color: '#01579B' },
  { id: 40, label: 'Laura S.',            time: '20:00', duration: 1,   col: 6, color: '#C2185B' },
  { id: 41, label: 'Meditation',          time: '18:30', duration: 1,   col: 7, color: '#AD1457' },
  { id: 42, label: 'Lisa M.',             time: '19:00', duration: 1,   col: 1, color: '#4A148C' },
  { id: 43, label: 'Rückenmassage',       time: '19:00', duration: 1.5, col: 2, color: '#0288D1' },
  { id: 44, label: 'Yoga',                time: '18:30', duration: 1,   col: 3, color: '#2E7D32' },
  { id: 45, label: 'Tanzkurs',            time: '19:30', duration: 1.5, col: 4, color: '#880E4F' },
  { id: 46, label: 'Friseur',             time: '17:00', duration: 1,   col: 5, color: '#388E3C' },
  { id: 47, label: 'Massage',             time: '19:00', duration: 1,   col: 5, color: '#006064' },
]

// Ein- und Ausblenden als CSS-Animation mit negativem Delay: jede Karte steht schon beim
// ersten Frame mitten in ihrem Zyklus, der Kalender ist also sofort gefüllt.
const CARD_PERIOD = 20 // s, eine Karte erscheint alle 20 s erneut und ist ~12 s sichtbar
const CARD_KEYFRAMES = `
@keyframes booking-rain-card {
  0%   { opacity: 0; }
  6%   { opacity: 1; }
  62%  { opacity: 1; }
  68%  { opacity: 0; }
  100% { opacity: 0; }
}`

function timeToPixel(time: string): number {
  const [h, m] = time.split(':').map(Number)
  return (h - 7) * HOUR_HEIGHT + (m / 60) * HOUR_HEIGHT
}

const TODAY = 2 // Wednesday highlighted as "today"

// Single calendar grid — rendered several times per layer for a seamless infinite loop.
// All copies of a layer must be identical (same timing), otherwise the loop jump is visible.
// Each layer gets its own share of the bookings; only the front layer draws the grid lines,
// so the parallax layers don't produce doubled hour labels and ghost cards.
function CalendarGrid({ layer, showGrid, animate }: { layer: number; showGrid: boolean; animate: boolean }) {
  const today = TODAY
  const bookings = BOOKINGS.filter((b) => b.id % LAYERS.length === layer)

  return (
    <div style={{ position: 'relative', width: '100%', height: GRID_HEIGHT }}>

      {/* Hour rows — identical structure to design-preview-v2.html .cal-hour-row */}
      {showGrid && HOURS.slice(0, -1).map((hour, i) => (
        <div
          key={hour}
          style={{
            position: 'absolute',
            top: i * HOUR_HEIGHT,
            left: 0,
            right: 0,
            height: HOUR_HEIGHT,
            display: 'grid',
            gridTemplateColumns: '52px repeat(7, 1fr)',
          }}
        >
          {/* Time label — .cal-time-lbl adapted for dark */}
          <div style={{
            fontSize: 10,
            fontWeight: 500,
            fontFamily: 'Inter, sans-serif',
            color: 'rgba(156,163,175,0.65)',
            textAlign: 'right',
            paddingRight: 8,
            paddingTop: 3,
            borderRight: '1px solid rgba(232,234,246,0.18)',
            display: 'flex',
            alignItems: 'flex-start',
            justifyContent: 'flex-end',
          }}>
            {hour}
          </div>

          {/* Day cells — .cal-day-cell adapted for dark */}
          {DAYS.map((_, di) => (
            <div
              key={di}
              style={{
                height: HOUR_HEIGHT,
                borderLeft: '1px solid rgba(232,234,246,0.18)',
                borderTop: i > 0 ? '1px dashed rgba(232,234,246,0.10)' : 'none',
                background: di === today
                  ? 'rgba(255,109,0,0.018)'  // today-bg from design-preview-v2.html
                  : di >= 5
                    ? 'rgba(200,200,215,0.015)'  // wknd-bg adapted for dark
                    : 'transparent',
              }}
            />
          ))}
        </div>
      ))}

      {/* Booking cards */}
      {bookings.map((booking) => {
        const top = timeToPixel(booking.time)
        const height = booking.duration * HOUR_HEIGHT - 4
        // Gleiche Periode für alle Karten, Phasen über die ganze Periode verteilt —
        // so ist der Kalender jederzeit gleich voll statt in Wellen voll und leer.
        // (Goldener-Schnitt-Folge, damit Nachbarn in Spalte und Zeit nie im Gleichtakt laufen)
        const phase = ((booking.id * 0.618034) % 1) * CARD_PERIOD

        return (
          <div
            key={booking.id}
            // Card — identical to .cal-evt from design-preview-v2.html
            style={{
              position: 'absolute',
              top: top + 2,
              left: `calc(52px + ${booking.col - 1} * (100% - 52px) / 7 + 2px)`,
              width: `calc((100% - 52px) / 7 - 4px)`,
              height,
              background: booking.color,
              borderRadius: 6,
              padding: '3px 6px',
              borderLeft: '2px solid rgba(255,255,255,0.35)',
              overflow: 'hidden',
              pointerEvents: 'none',
              opacity: animate ? 0 : 1,
              animation: animate
                ? `booking-rain-card ${CARD_PERIOD}s linear ${-phase}s infinite`
                : 'none',
            }}
          >
            {/* Highlight gradient — .cal-evt::after */}
            <div style={{
              position: 'absolute', top: 0, left: 0, right: 0, height: '40%',
              background: 'linear-gradient(rgba(255,255,255,0.1), transparent)',
              pointerEvents: 'none',
            }} />
            <div style={{
              fontSize: 10, fontWeight: 700, color: 'white',
              fontFamily: 'Plus Jakarta Sans, sans-serif',
              whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis',
              textShadow: '0 1px 2px rgba(0,0,0,0.18)',
              lineHeight: 1.3,
              position: 'relative',
            }}>
              {booking.label}
            </div>
            <div style={{
              fontSize: 9, color: 'rgba(255,255,255,0.78)', fontWeight: 500,
              position: 'relative',
            }}>
              {booking.time}
            </div>
          </div>
        )
      })}
    </div>
  )
}

// Layer config — different speeds create parallax depth (last entry = front layer)
// scale < 1 rückt die hinteren Ebenen in die Tiefe, ihre Spalten liegen dadurch versetzt
// zu den vorderen statt Karte auf Karte.
const LAYERS = [
  { opacity: 0.22, duration: 65, scale: 0.72 },
  { opacity: 0.38, duration: 44, scale: 0.86 },
  { opacity: 0.58, duration: 28, scale: 1 },
]
const FRONT_LAYER = LAYERS.length - 1

// Today pill + current-time line — drawn once and fixed, so the week flows past "now"
// instead of the markers repeating with every grid copy.
function TodayMarkers() {
  const columnLeft = `calc(52px + ${TODAY} * (100% - 52px) / 7)`
  const columnWidth = 'calc((100% - 52px) / 7)'

  return (
    <div style={{ position: 'absolute', inset: 0, pointerEvents: 'none' }}>
      {/* .cal-wday-num.today-pill */}
      <div style={{
        position: 'absolute',
        top: 84, // unter der fixen Navigation
        left: `calc(${columnLeft} + (100% - 52px) / 14 - 16px)`,
        width: 32, height: 32,
        borderRadius: '50%',
        background: '#FF6D00',
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        boxShadow: '0 4px 10px rgba(255,109,0,0.35)',
        fontSize: 14, fontWeight: 700, color: 'white',
        fontFamily: 'Plus Jakarta Sans, sans-serif',
      }}>
        4
      </div>

      {/* .cal-now-line */}
      <div style={{
        position: 'absolute',
        top: timeToPixel('10:30'),
        left: columnLeft,
        width: columnWidth,
        height: 2,
        background: '#FF6D00',
        zIndex: 5,
      }}>
        <div style={{
          position: 'absolute',
          left: -4, top: -4,
          width: 10, height: 10,
          borderRadius: '50%',
          background: '#FF6D00',
          boxShadow: '0 0 0 3px rgba(255,109,0,0.2)',
        }} />
      </div>
    </div>
  )
}

export function BookingRainBackground() {
  const reduceMotion = useReducedMotion()

  return (
    <div
      style={{
        position: 'fixed',
        inset: 0,
        zIndex: 0,
        overflow: 'hidden',
        background: '#0E0B1E',
      }}
    >
      <style>{CARD_KEYFRAMES}</style>

      {/* 3D perspective container */}
      <div style={{
        position: 'absolute',
        inset: 0,
        transform: 'perspective(1200px) rotateX(6deg) rotateZ(-1.5deg)',
        transformOrigin: 'center top',
      }}>
        {LAYERS.map((layer, i) => (
          <div
            key={i}
            style={{
              position: 'absolute',
              top: 0,
              bottom: 0,
              // breiter anlegen und herunterskalieren, damit die Ebene trotzdem die volle Breite füllt
              left: `${(100 - 100 / layer.scale) / 2}%`,
              width: `${100 / layer.scale}%`,
              transform: `scale(${layer.scale})`,
              transformOrigin: 'center top',
              opacity: layer.opacity,
              willChange: 'transform',
            }}
          >
            <motion.div
              animate={reduceMotion ? {} : { y: [0, -GRID_HEIGHT] }}
              transition={{
                duration: layer.duration,
                repeat: Infinity,
                ease: 'linear',
              }}
              style={{ willChange: 'transform' }}
            >
              {/* 3 identical copies for seamless loop on any screen height */}
              {[0, 1, 2].map((copy) => (
                <CalendarGrid key={copy} layer={i} showGrid={i === FRONT_LAYER} animate={!reduceMotion} />
              ))}
            </motion.div>
            {i === FRONT_LAYER && <TodayMarkers />}
          </div>
        ))}
      </div>

      {/* Radial vignette — keeps foreground readable */}
      <div
        style={{
          position: 'absolute',
          inset: 0,
          background: 'radial-gradient(ellipse 90% 80% at 50% 50%, rgba(14,11,30,0.15) 0%, rgba(14,11,30,0.35) 40%, rgba(14,11,30,0.78) 100%)',
          pointerEvents: 'none',
        }}
      />
    </div>
  )
}
